import { Box, Button, Container, Header, SpaceBetween } from '@amzn/awsui-components-console';
import { useAuth } from '../hooks/useAuth';

/**
 * Access Denied Page
 *
 * Displayed when an authenticated user has no channels allowlisted.
 * Follows Cloudscape access denied error pattern.
 */
export function AccessDeniedPage() {
  const { logout } = useAuth();

  return (
    <Box padding={{ vertical: 'xxxl', horizontal: 'l' }}>
      <Box margin={{ top: 'xxxl' }}>
        <SpaceBetween size="l" alignItems="center">
          <Container header={<Header variant="h1">Access denied</Header>}>
            <SpaceBetween size="m">
              <Box variant="p">
                Your account does not have any channels configured. Contact AWS Secret Region
                support to request access.
              </Box>
              <Button onClick={logout}>Sign out</Button>
            </SpaceBetween>
          </Container>
        </SpaceBetween>
      </Box>
    </Box>
  );
}
